import { PureComponent, ReactPortal } from "react";
import { createPortal } from "react-dom";

export interface IPortal {
  node?: HTMLElement | null;
  open?: boolean;
}

/**
 * Portal is a component to display content in portal (modal)
 */
class Portal extends PureComponent<IPortal> {
  getRootNode() {
    const { node } = this.props;
    return node || document.body;
  }

  render() {
    const { children, open } = this.props;

    if (open) {
      return createPortal(children, this.getRootNode()) as ReactPortal;
    }

    return null;
  }
}
export default Portal;
